import React, { useMemo } from 'react'
import { Typography } from 'gu-ui-kit'
import BudgetControls from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/subcomponents/ControlsPanel/subcomponents/BudgetControls'
import DatesControls from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/subcomponents/ControlsPanel/subcomponents/DatesControls'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const ControlsPanel = ({ type, resource }) => {
  const { t } = useTranslation()

  const Panel = useMemo(() => {
    switch (type) {
      case 'budget':
        return BudgetControls
      case 'dates':
        return DatesControls
    }
  }, [type])

  return (
    <div>
      <Typography
        variant={'Body-15'}
        className={'margin-bottom-16'}
        component={'div'}
      >
        {t('campaigns_editor::budget_editor.controls_panel.description', {
          context: resource,
        })}
      </Typography>
      <Panel resource={resource} />
    </div>
  )
}

export default ControlsPanel

ControlsPanel.propTypes = {
  type: PropTypes.string,
  resource: PropTypes.string,
}
